import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useAdminNotificationsContext } from "@/shared/contexts/AdminNotificationsProvider";

export const CommunicationCounter = memo(() => {
  const { counts } = useAdminNotificationsContext();
  return <NotificationBadge count={counts.communication_unread ?? 0} />;
});

CommunicationCounter.displayName = "CommunicationCounter";
